import { render, staticRenderFns } from "./CreateGroupBanner.vue?vue&type=template&id=d6be9cf6&"
import script from "./CreateGroupBanner.vue?vue&type=script&lang=js&"
export * from "./CreateGroupBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports